__turbopack_context__.v({
  "button": "BottomOverlay-module__6Nr3pG__button",
  "column": "BottomOverlay-module__6Nr3pG__column",
  "container": "BottomOverlay-module__6Nr3pG__container",
});
